import React, { ReactNode, createContext } from 'react';
import { HeliumContextValue } from '../types';

export const HeliumContext = createContext<HeliumContextValue>({});

export const HeliumProvider = ({ children, ...props }: HeliumContextValue & { children: ReactNode }) => (
	<HeliumContext.Provider value={props}>{children}</HeliumContext.Provider>
);
